import { COLORS } from 'src/theme/palette';
import { makeStyles } from 'src/utils/makeStyles';

const styles = makeStyles({
  wrapper: {
    padding: '5px',
    border: `1px solid ${COLORS.black20}`,
    marginBottom: '-1px',
    borderRadius: '4px 4px 0 0',
    counterReset: 'wrapper',
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
  },
  box: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '4px',
  },
});

export default styles;
